import { useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { Link } from "react-router-dom";
import "../../assets/css/searchmenu.css";

function ViewAll({ data = [] }) {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  // split data into columns
  const columns = 6;
  const perColumn = Math.ceil(data.length / columns);

  return (
    <>
      <Link
        onClick={handleShow}
        style={{
          color:"#FFF",
          fontSize:"12px",
          paddingRight:"38px",
          cursor:"pointer"
        }}
      >
        VIEW MORE ...
      </Link>

      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        fullscreen
        className="modal-search"
      >
        <Modal.Header style={{ border: "none", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <div className="search-menu" style={{ flexGrow: 1 }}>
            <i className="bi bi-search search-icon"></i>
            <input type="search"  className="form-control" />
          </div>
          {/* Custom Close Button */}
          <Button variant="link" onClick={handleClose} className='btnclose' style={{ color: "gray", textDecoration: "none", background:"#FFF" }}>
            <i className="bi bi-x-lg" style={{ fontSize: "18px" }}></i>
          </Button>
        </Modal.Header>
       
        <Modal.Body>
          <div className="row">
          {
            Array.from({length:columns}).map((_,index)=>(
              <div
                className="col-md-2"
                key={index}
              >
                <ul className="nevcolor">
                {
                  data
                  .slice(
                    index * perColumn,
                    (index + 1) * perColumn
                  )
                  .map((item)=>(
                    <li key={item.quality_action_link}>
                      <Link
                        className="nevcolor"
                        to={`/products/${item.quality_action_link}`}
                        onClick={handleClose}
                      >
                        {item.quality_name}
                      </Link>
                    </li>
                  ))
                }
                </ul>
              </div>
            ))
          }
          </div>
        </Modal.Body>
      </Modal>

    </>
  );
}


export default ViewAll;